<script>
export default {
  computed: {
    file_path() {
      const is_dark = this.$vuetify.theme.isDark
      return is_dark ? this.src.dark : this.src.light
    }
  },
  name: 'doc-image',
  props: {
    src: {type: Object, default: () => {}},
    caption: {type: String, default: () => null},
    link: {type: String, default: () => null},
    props: {type: Object, default: () => ({})}
  }
}
</script>

<template>
<div class='doc-image d-flex flex-column my-2'>
  <router-link v-if='link' :to='link'>
    <v-img v-if='file_path' v-bind='props' :src='load_image(file_path)'
      class='my-2 link' :alt='caption'>
      <template v-slot:placeholder>
        <v-row  class='fill-height ma-0' align='center' justify='center'>
          <v-progress-circular indeterminate color='primary'/>
        </v-row>
      </template>
    </v-img>
  </router-link>
  <v-img v-if='!link && file_path' v-bind='props' :src='load_image(file_path)'
    class='my-2' :alt='caption'>
    <template v-slot:placeholder>
      <v-row  class='fill-height ma-0' align='center' justify='center'>
        <v-progress-circular indeterminate color='primary'/>
      </v-row>
    </template>
  </v-img>
  <div class='d-flex flex-grow-1 justify-center body-2'>
    <span>{{caption}}</span>
  </div>
</div>
</template>

<style lang='sass' scoped>
.link
  border: 1px solid transparent
  transition: all 0.5s
  &:hover
    border: 1px solid var(--v-secondary-base)
</style>
